export const VERSIONDATE = 1788335403; export const MYISAVERSION = 'master-21.10.60-73'
